var map = {
	"./Pictures/Flyers/2022_03_12_SpiceRack_Flyer.jpg": 9683,
	"./Pictures/Flyers/2023_08_11_Annex_Flyer.jpg": 4631,
	"./Pictures/Flyers/2024_03_09_Annex_Flyer.jpg": 4492,
	"./Pictures/Flyers/2024_06_14_Subterranean_Flyer.jpg": 2938,
	"./Pictures/Flyers/2024_07_11_Linnemans_Flyer.jpg": 3876,
	"./Pictures/Flyers/2024_09_06_UnionTerrace_Flyer.jpeg": 7473,
	"./Pictures/Flyers/2024_10_25_SpiceRack_Flyer.jpg": 8184,
	"./Pictures/Flyers/2025_01_23_CanopyClub_Flyer.jpg": 4093,
	"./Pictures/Flyers/2025_01_24_BeatKitchen_Flyer.jpeg": 687,
	"./Pictures/Icons/NSLogoWhite.png": 241,
	"./Pictures/Icons/greenarrow3.png": 6211,
	"./Pictures/Icons/mapIcon.png": 8796,
	"./Pictures/Icons/spotifytrans.png": 2486,
	"./Pictures/Icons/tiktokLogoBlack.png": 3464,
	"./Pictures/Icons/tiktokLogoColor.png": 930,
	"./Pictures/Performances/2022_03_12_SpiceRack/FullBandPlaying.jpg": 4955,
	"./Pictures/Performances/2022_03_12_SpiceRack/Fullbandsick3.jpg": 9611,
	"./Pictures/Performances/2022_03_12_SpiceRack/JunRedBacklight.jpg": 8695,
	"./Pictures/Performances/2022_03_12_SpiceRack/KieranGuitar.jpg": 5807,
	"./Pictures/Performances/2022_03_12_SpiceRack/PJfrontKieranBackGreen.jpg": 5817,
	"./Pictures/Performances/2022_03_12_SpiceRack/bigJunbass2.jpg": 4493,
	"./Pictures/Performances/2023_08_11_Annex/annex1-min.jpg": 754,
	"./Pictures/Performances/2023_08_11_Annex/annex2-min.jpg": 9702,
	"./Pictures/Performances/2023_08_11_Annex/annex3-min.jpg": 6160,
	"./Pictures/Performances/2023_08_11_Annex/annex4-min.jpg": 1976,
	"./Pictures/Performances/2023_08_11_Annex/annex5-min.jpg": 2191,
	"./Pictures/Performances/2023_08_11_Annex/concert.jpg": 7255,
	"./Pictures/Performances/2024_03_09_Annex/IMG_7075.jpg": 5910,
	"./Pictures/Performances/2024_03_09_Annex/IMG_7105.jpg": 6394,
	"./Pictures/Performances/2024_03_09_Annex/IMG_7130.jpg": 8458,
	"./Pictures/Performances/2024_03_09_Annex/IMG_7213.jpg": 345,
	"./Pictures/Performances/2024_03_09_Annex/IMG_7219.jpg": 9538,
	"./Pictures/Performances/2024_03_09_Annex/IMG_7288.jpg": 122,
	"./Pictures/Performances/2025_01_24_BeatKitchen/beatkitchen1.jpg": 9307,
	"./Pictures/Performances/2025_01_24_BeatKitchen/beatkitchen2.jpg": 7334,
	"./Pictures/Performances/2025_01_24_BeatKitchen/beatkitchen3.jpg": 6866,
	"./Pictures/Performances/2025_01_24_BeatKitchen/beatkitchen4.jpg": 2151,
	"./Pictures/Performances/2025_01_24_BeatKitchen/beatkitchen5.jpg": 6621,
	"./Pictures/Profile/ByWater.png": 798,
	"./Pictures/Profile/june23pic2.jpg": 3370,
	"./Pictures/Profile/june23pic3.JPG": 331,
	"./Pictures/Profile/june23pic4.JPG": 961,
	"./Pictures/Profile/profilepic1.jpg": 7599,
	"./Pictures/Profile/profilepic2.JPG": 8900,
	"./Pictures/Profile/profilepic3.JPEG": 3241,
	"./Pictures/TikTokScreenshots/fearOfRegretTikTok.png": 9425,
	"./Pictures/TikTokScreenshots/headphonesOnTikTok.png": 4564,
	"./Pictures/TikTokScreenshots/headphonesOnTikTok2.png": 9432,
	"./Pictures/TikTokScreenshots/headphonesOnTikTok3.png": 8949,
	"./Pictures/TikTokScreenshots/imageTikTok.png": 1556,
	"./Pictures/TikTokScreenshots/imageTikTok2.png": 477,
	"./Pictures/TikTokScreenshots/nmlTikTok.png": 4483,
	"./Pictures/TikTokScreenshots/ttmTikTok.png": 1453,
	"./Pictures/TikTokScreenshots/ttmTikTok2.png": 6384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2078;